const HOME = 'HOME PAGE'
const EDITORS = 'EDITORS'
const FEATURED_WORK = 'FEATURED WORK'
const NEWS = 'NEWS'
const CONTACT = 'CONTACT'

export const menusNames = {
    HOME: HOME,
    EDITORS: EDITORS,
    FEATURED_WORK: FEATURED_WORK,
    NEWS: NEWS,
    CONTACT: CONTACT,
}

export const menuProps = {
    NAME: 'name',
    SLUG: 'slug',
    LINK: 'link',
    SEO: 'seo',
}
